module.exports = __webpack_public_path__ + "img/webhooks.b2486a2.png";